import React from 'react';

import InternationalizationStore from '../../../store/internationalization-store.js'
import { FormControl, FormGroup, Form, Row, Col } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import InternationalisationStore from '../../../store/internationalization-store.js';
import LanguageSelector from "../../language_select.js";
import LanguageInterfaceSelector from "../../language_select.js";
import Select from 'react-select';
import { DateRangePicker} from 'react-dates';
import moment from 'moment';
import Translation from '../../../store/internationalization-store.js';
class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{InternationalizationStore.get(this.props.id , this.props.defaultMessage)}</span>
    }
}

class Component extends React.Component {
    constructor(props) {
        super();
        this.props = props

        this.state = {
            startDate:moment(),
            endDate:moment().add(14, "days"),
        }

        var printables = [
            { name: "Achivement", text:<FormattedMessage id={'0'} defaultMessage={'Achivement Certificate'} />,},
        ]

        this.options = printables.map(function (printable) {
            return { value: printable.name, label: printable.text }
        });

        this.value = this.options[0];
        this.props.data.printable = this.options[0].value;
        this.props.data.level = 1;
    }

    onSelect (e) {
            this.props.data.printable = e.value;
            this.value = e;
            this.setState({ value: e });
    }

    onSelectLevel (e) {
            var lvl = e.value;
            this.levelValue = e;
            if (lvl == "Level 1" ){
                this.props.data.level = 1;
            } else if (lvl == "Level 2"){
                this.props.data.level = 2;
            } else {
                this.props.data.level = 3;
            }
            this.setState({ levelValue: e });
    }

    handleSelectLanguage (language) {
        console.log(language)
            this.props.data.selectedLanguage = language;
            this.setState({selectedLanguage : language});
    }

    handleSelectInterfaceLanguage (language) {
        console.log(language)
            this.props.data.selectedInterfaceLanguage = language;
            this.setState({selectedInterfaceLanguage : language});
    }

    render (){

        return   <div>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'330'} defaultMessage={'Choose Printable'} /></Form.Label>
                                    <Select onChange={this.onSelect.bind(this)} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"2011"} defaultMessage={"No Results Found"} />}
                                            placeholder={<FormattedMessage id={'892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>
                            <Col md={"auto"} style={{marginTop:"28px", marginBottom:"auto"}} >
                                <DateRangePicker
                                    displayFormat='DD/MM/YYYY'
                                    className="hellp"
                                    customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                    startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                    endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                    />
                            </Col>
                        </Row>
                        <Row className="p-b-20"></Row>
                    </div>
    }


}

export default {
    name: <FormattedMessage id={'0'} defaultMessage={'Select Certificate'} />,
    title: null,
    onSubmit: function (done) {
        return done()
    },
    value: null,
    component: Component
}